<section class="seo-service">
    <div class="container-fluid">
        <div class="row center-align">
            <div class="col-md-6">
                <div class="service px-1 px-md-5">
                    <h2 class="text-start web-design-title">
                        {{"Web design by codesroots" | translate}}
                    </h2>
                    <p>
                        {{"The Internet has become the largest means of communication with others, especially with regard to the field of business, and in many cases the customer has a specific idea to create his site so that the idea meets the desired goal of his establishment or the nature of his work, and some ideas need to be done with custom programming to meet the requirements of the site and the purpose of its establishment. We at CodesRoots have A software team is fully prepared to meet all the software required by the client in the best way, as we use multiple programming languages, especially the php language, which is the most used in software applications, and we seek all available means and technologies to present the site in the best form that the client aspires to" | translate}}
                    </p>
                    <p>
                        {{"We do not consider website design as our job only, but we love working on it and we try hard to produce everything new in the field of website design. Our motto is commitment, then quality. We want to assure you that you will not get work unless you are 100 percent satisfied with it, because we aspire to become the best programming company. in the Arab world" | translate}}
                    </p>
                </div>
            </div>
            <div class="col-md-6 text-center">
                <img src="./../../../assets/images/web-design-section.png" alt="seo" />
            </div>
        </div>
    </div>
</section>
